<template>
  <!-- <PreloaderComp :isLoading="isLoading" /> -->
  <main>
    <router-view />
  </main>
</template>

<script>
import HomeView from "./views/HomeView.vue";
import AssetView from "./views/AssetView.vue";
import AssetDetailView from "./views/AssetDetailView.vue";

export default {
  name: "App",
  components: {
    HomeView,
    AssetView,
    AssetDetailView,
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body,
html {
  font-family: "Nunito", sans-serif;
  overflow-x: hidden;
}
</style>
